import { render } from "./IconTransfer.vue?vue&type=template&id=d9650162"
import script from "./IconTransfer.vue?vue&type=script&lang=js"
export * from "./IconTransfer.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__